module.exports = __webpack_public_path__ + "static/media/founders-lambo.b4bdfa7f.png";